import { render, staticRenderFns } from "./AssessmentFarmerDimitraDetails.vue?vue&type=template&id=70116bd3&scoped=true"
import script from "./AssessmentFarmerDimitraDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentFarmerDimitraDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFarmerDimitraDetails.vue?vue&type=style&index=0&id=70116bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70116bd3",
  null
  
)

export default component.exports